export default __webpack_public_path__ + "static/reed-2-7f9aa3c50ef2d6ed901b0f80f58acf53.png";